var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLargeAlertinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.667 28.333a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0ZM21.667 23.333v-15h-3.334v15h3.334Z",
  fill: "#E2175A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Zm0-1.667c10.125 0 18.333-8.208 18.333-18.333C38.333 9.875 30.125 1.667 20 1.667 9.875 1.667 1.667 9.875 1.667 20c0 10.125 8.208 18.333 18.333 18.333Z",
  fill: "#E2175A"
})));
export default SvgLargeAlertinline;